import { render, staticRenderFns } from "./BaseBackground.vue?vue&type=template&id=0a51fc1e&"
import script from "./BaseBackground.vue?vue&type=script&lang=ts&"
export * from "./BaseBackground.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports